import * as ActionTypes from './actionTypes'

const TOKEN_KEY = 'nek0t'
const USER_KEY = 'r3su'
const TOKEN_EXPIRATION_KEY = 'token_age'

const initialState = {
  isLoggedIn: false,
  isLoggingIn: false,
  error: null,
  permissions: null,
  token: null
}

export const NAME = 'auth'

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.LOGIN_FAIL:
      return {
        ...state,
        isLoggedIn: false,
        isLoggingIn: false,
        error: action.error
      }
    case ActionTypes.LOGIN_START:
      return {
        ...state,
        isLoggingIn: true
      }
    case ActionTypes.LOGIN_SUCCESS:
      try {
        window.localStorage.setItem(TOKEN_KEY, action.token)
        window.localStorage.setItem(TOKEN_EXPIRATION_KEY, new Date())
        window.localStorage.setItem(USER_KEY, JSON.stringify(action.user))
      } catch (e) {
        console.error('Failed to store token or user', e)
      }
      return {
        ...state,
        permissions: action.user.permissions,
        token: action.token,
        isLoggedIn: true,
        isLoggingIn: false,
        error: null
      }
    case ActionTypes.LOGOUT:
      window.localStorage.removeItem(TOKEN_KEY)
      window.localStorage.removeItem(USER_KEY)
      return initialState
    case ActionTypes.INIT:
      return {
        ...state,
        isLoggedIn: !!action.token,
        token: action.token,
        permissions: action.user && action.user.permissions
      }
    default:
      return state
  }
}

export const loadTokenAndUserFromStorage = () => {
  const token = window.localStorage.getItem(TOKEN_KEY) || null
  if (token === null) return [null, null]

  let tokenExpiration =
    window.localStorage.getItem(TOKEN_EXPIRATION_KEY) || null
  if (tokenExpiration === null) return [null, null]
  const expirationDate = new Date(tokenExpiration)
  if (new Date() - expirationDate > 1000 * 60 * 60) {
    return [null, null]
  }
  const user = window.localStorage.getItem(USER_KEY) || null
  if (user === null) return [null, null]
  return { token, user: JSON.parse(user) }
}

export default reducer
